const notFouncContent = {
  error: 'ERROR 404',
  subtitle: 'Parece que esta luna está abandonada.',
  notFound: '(página no encontrada)'
}

export default notFouncContent
